import React, { useEffect } from 'react'
import AccessNavigator, { createNewRouter } from '../AccessNavigator'
import CountdownProvider from '../../../util/providers/CountdownProvider'
import { SendPhone2FAPage } from '../SendPhone2FAPage'
import { CheckPhone2FAPage } from '../CheckPhone2FAPage'
import { FocusHeader } from '@olxbr/ds-web'
import getSessionTokenInfos from '../../../util/sessionTokenGetter'
import { SEND_MODES } from '../../templates/CheckPinCodeTemplate'

const router = createNewRouter('SendPhone2FAPage')
const PUBLIC_ACCOUNT_ID_EVENT_DEFAULT = 'no_public_account_id'

const Phone2FALoginChallenge = ({
  phone,
  token,
  onChooseAnotherMethodClick,
  onSuccess,
  onAccountNotValidated,
  abTests,
  redirectToVerifyYourAccess,
  modalMode,
  onAccountCompleteData,
}) => {
  const getInitialSendMode = () => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('sendMode') || SEND_MODES.WHATSAPP
  }

  const [sessionTokens, setSessionTokens] = React.useState(null)
  const [publicAccountId, setPublicAccountId] = React.useState(PUBLIC_ACCOUNT_ID_EVENT_DEFAULT)
  const [pinCodeSendMode, setPinCodeSendMode] = React.useState(getInitialSendMode())

  const updateSendMode = mode => {
    setPinCodeSendMode(mode)

    const url = new URL(window.location)
    url.searchParams.set('sendMode', mode)
    window.history.replaceState({}, '', url)
  }

  const onSendCodeSuccess = () => {
    router.push('CheckPhone2FAPage')
  }

  const goBack = e => {
    if (e) e.preventDefault()
    if (router.canPop()) {
      router.pop()
    } else {
      router.push('SendPhone2FAPage')
    }
  }

  const getSessionResult = async () => {
    const sessionTokensResult = await getSessionTokenInfos()
    if (sessionTokensResult) {
      setSessionTokens(sessionTokensResult)
    }
  }

  useEffect(() => {
    getSessionResult()
  }, [])

  return (
    <CountdownProvider>
      {!modalMode && <FocusHeader />}
      <AccessNavigator
        router={router}
        routes={[
          {
            route: 'SendPhone2FAPage',
            component: () => (
              <SendPhone2FAPage
                phone={phone}
                onSuccess={onSendCodeSuccess}
                onChooseAnotherMethodClick={onChooseAnotherMethodClick}
                token={token}
                onChooseSendMode={updateSendMode}
                abTests={abTests}
                redirectToVerifyYourAccess={redirectToVerifyYourAccess}
                onGetPublicAccountId={setPublicAccountId}
                modalMode={modalMode}
              />
            ),
          },
          {
            route: 'CheckPhone2FAPage',
            component: () => (
              <CheckPhone2FAPage
                phone={phone}
                token={token}
                onSuccess={onSuccess}
                onBackClick={goBack}
                defaultSendMode={pinCodeSendMode}
                abTests={abTests}
                onAccountNotValidated={onAccountNotValidated}
                sessionTokens={sessionTokens}
                publicAccountId={publicAccountId}
                modalMode={modalMode}
                onAccountCompleteData={onAccountCompleteData}
              />
            ),
          },
        ]}
      />
    </CountdownProvider>
  )
}

export { Phone2FALoginChallenge }
